import { BaseEnvironment, BASE_ENVIRONMENT } from './base';

export const environment: BaseEnvironment = {
  ...BASE_ENVIRONMENT,
  production: true,
  apiUrl: 'https://api.anglersatlas.com/v1',
};
